// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"0494d4df","357":"ee1bad59","529":"4b8e8db1","791":"5d817cbc","852":"814e7094","944":"cee56f9f"}[chunkId] + ".chunk.js";
};